import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';

export const LOAD_SUCCESS = 'LOAD_WCC_SUCCESS';
export const LOAD_FAIL = 'LOAD_WCC_FAIL';
export const LOAD_REQUEST = 'LOAD_WCC_REQUEST';
export const LOAD_OPTIONS_SUCCESS = 'LOAD_WCC_OPTIONS_SUCCESS';

export const SUBMIT_SUCCESS = 'SUBMIT_WCC_SUCCESS';
export const SUBMIT_FAIL = 'SUBMIT_WCC_FAIL';
export const SUBMIT_REQUEST = 'SUBMIT_WCC_REQUEST';

export const DELETE_FAIL = 'DELETE_WCC_FAIL';
export const DELETE_REQUEST = 'DELETE_WCC_REQUEST';
export const DELETE_SUCCESS = 'DELETE_WCC_SUCCESS';

export const UPDATE_SUCCESS = 'UPDATE_WCC_SUCCESS';
export const UPDATE_FAIL = 'UPDATE_WCC_FAIL';
export const UPDATE_REQUEST = 'UPDATE_WCC_REQUEST';

const loadWccRequest = () => ({ type: LOAD_REQUEST });
const loadWccFail = (error) => ({ type: LOAD_FAIL, error });
const loadWccSuccess = (wcc) => ({ type: LOAD_SUCCESS, wcc });
const loadWccOptionsSuccess = (options) => ({ type: LOAD_OPTIONS_SUCCESS, options });

const submitWccRequest = (wcc) => ({ type: SUBMIT_REQUEST, wcc });
const submitWccSuccess = (result) => ({ type: SUBMIT_SUCCESS, result });
const submitWccFail = (error) => ({ type: SUBMIT_FAIL, error });

const deleteWccRequest = (wcc) => ({ type: DELETE_REQUEST, wcc });
const deleteWccFail = (error) => ({ type: DELETE_FAIL, error });
const deleteWccSuccess = (wccId) => ({ type: DELETE_SUCCESS, wccId });

const updateWccRequest = (wcc) => ({ type: UPDATE_REQUEST, wcc });
const updateWccSuccess = (result) => ({ type: UPDATE_SUCCESS, result });
const updateWccFail = (error) => ({ type: UPDATE_FAIL, error });

const reformatWccForOptionsMenu = (data) => data.map((wcc) => ({
  value: wcc.Id.toString(),
  label: wcc.WorkCenterCodeName
}));


export const loadWcc = () => (dispatch) => {
  dispatch(loadWccRequest());
  return communicate({
    url: 'WorkCenterCodes',
    method: 'get'
  })
    .then((response) => {
      dispatch(loadWccSuccess(response.data.Data));
      dispatch(loadWccOptionsSuccess(reformatWccForOptionsMenu(response.data.Data)));
    }).catch((err) => {
      dispatch(loadWccFail(err));
      toastrError(err);
    });
};

export const deleteWcc = (wccId) => (dispatch) => {
  dispatch(deleteWccRequest(wccId));
  return communicate({
    url: 'WorkCenterCodes',
    method: 'delete',
    getParams: `?id=${wccId}`
  })
    .then((response) => {
      toastrSuccess(response);
      dispatch(deleteWccSuccess(wccId));
    }).catch((err) => {
      dispatch(deleteWccFail(err));
      toastrError(err);
    });
};

export const updateWcc = (wcc) => (dispatch) => {
  dispatch(updateWccRequest(wcc));
  return communicate({
    url: 'WorkCenterCodes',
    method: 'put',
    data: wcc
  })
    .then((response) => {
      dispatch(updateWccSuccess(response.data.Data));
      toastrSuccess(response);
    }).catch((err) => {
      dispatch(updateWccFail(err));
      toastrError(err);
    });
};

export const submitWcc = (wcc) => (dispatch) => {
  dispatch(submitWccRequest(wcc));
  return communicate({ url: 'WorkCenterCodes', method: 'post', data: wcc })
    .then((response) => {
      dispatch(submitWccSuccess(response.data.Data));
      toastrSuccess(response);
    }).catch((err) => {
      dispatch(submitWccFail(err));
      toastrError(err);
    });
};
